import { useState } from "react";
import { GetFinanceAccountsResponseModel } from "@/features/accounts/finance/services/get-accounts-model";


export const useGetFinanceAccountStates = () => {
  const [institutionType, setInstitutionType] = useState("");
  const [financeAccountId, setFinanceAccountId] = useState("");
  const [financeAccounts, setFinanceAccounts] = useState<GetFinanceAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    institutionType,
    setInstitutionType,
    financeAccountId,
    setFinanceAccountId,
    financeAccounts,
    setFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
